import React from 'react';
import moment from 'moment-timezone';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDBox, FDPaper, FDStack, FDIcon, FDBodyText,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import CopyWrapper from 'Components/ComponentLibrary/Components/Uncategorized/CopyWrapper/CopyWrapper';

const HouseholdInfoSectionLayout = () => {
  const { resource } = useMetaLayoutContext();
  const [localTime, setLocalTime] = React.useState('');

  const timezone = resource.attr('timezone');

  const calculateLocalTime = () => {
    const isRecognizableTimezone = moment.tz.zone(timezone);

    if (isRecognizableTimezone) {
      setLocalTime(moment.tz(moment(), timezone).format('LT'));
      return;
    }
    setLocalTime('');
  };

  // Calculate local time every 10 seconds
  React.useEffect(() => {
    calculateLocalTime();
    const intervalId = setInterval(calculateLocalTime, 10000);
    return () => clearInterval(intervalId);
  }, [timezone]);

  return (
    <FDPaper appearance={'elevated'} margin={300}>
      <FDBox padding={400}>
        <FDStack spacing={3}>
          <CopyWrapper value={resource.attr('householdId')}>
            <FDStack alignItems={'center'} spacing={1}>
              <FDIcon icon={'home'} color={'info'} />
              <MetaControlField attr={'householdId'} />
            </FDStack>
          </CopyWrapper>
          <FDStack alignItems={'center'} spacing={1}>
            <FDIcon icon={'accessTime'} color={'info'} />
            <FDStack direction={'row'} spacing={0.5}>
              <MetaControlField attr={'timezone'} />
              <FDBodyText size={'sm'} value={localTime} />
            </FDStack>
          </FDStack>
          <FDStack alignItems={'center'} spacing={1}>
            <FDIcon icon={'location'} color={'info'} />
            <MetaControlField attr={'location'} />
          </FDStack>
        </FDStack>
        <FDBox paddingY={2}>
          <FDStack wrap>
            <MetaControlField attr={'clients'} />
            <FDBox flex={1}>
              <MetaControlField attr={'familyMembers'} />
            </FDBox>
          </FDStack>
        </FDBox>
      </FDBox>
    </FDPaper>
  );
};

HouseholdInfoSectionLayout.defaultProps = {};

HouseholdInfoSectionLayout.propTypes = {};

export default HouseholdInfoSectionLayout;
